import {
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
  writeBatch,
  addDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

function requireDb() {
  if (!db) {
    throw new Error('Firestore is not configured. Add REACT_APP_FIREBASE_* values to .env.local.');
  }
}

function timestampValue(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  return Number(new Date(value)) || 0;
}

export async function createUserNotification(ownerId, notification) {
  requireDb();
  if (!ownerId || ownerId === notification.actorId) return null;
  const ref = await addDoc(collection(db, 'notifications', ownerId, 'items'), {
    ownerId,
    actorId: notification.actorId,
    actorName: notification.actorName || 'Cyberautography',
    type: notification.type,
    title: notification.title,
    body: notification.body || '',
    href: notification.href || '/dashboard/problems',
    read: false,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

export async function listUserNotifications(ownerId) {
  requireDb();
  const snapshot = await getDocs(collection(db, 'notifications', ownerId, 'items'));
  return snapshot.docs
    .map((entry) => ({ id: entry.id, ...entry.data() }))
    .sort((a, b) => timestampValue(b.createdAt) - timestampValue(a.createdAt));
}

export async function unreadNotificationCount(ownerId) {
  const notifications = await listUserNotifications(ownerId);
  return notifications.filter((notification) => !notification.read).length;
}

export async function markNotificationRead(ownerId, notificationId) {
  requireDb();
  await updateDoc(doc(db, 'notifications', ownerId, 'items', notificationId), {
    read: true,
    readAt: serverTimestamp(),
  });
}

export async function markAllNotificationsRead(ownerId, notifications) {
  requireDb();
  const batch = writeBatch(db);
  notifications.filter((notification) => !notification.read).forEach((notification) => {
    batch.update(doc(db, 'notifications', ownerId, 'items', notification.id), {
      read: true,
      readAt: serverTimestamp(),
    });
  });
  await batch.commit();
}
